/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IconsOpenEye1 = ({ className }) => {
  return (
    <svg
      className={`icons-open-eye-1 ${className}`}
      fill="none"
      height="25"
      viewBox="0 0 24 25"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12 4.58423C7 4.58423 2.73 7.69423 1 12.0842C2.73 16.4742 7 19.5842 12 19.5842C17 19.5842 21.27 16.4742 23 12.0842C21.27 7.69423 17 4.58423 12 4.58423ZM12 17.0842C9.24 17.0842 7 14.8442 7 12.0842C7 9.32423 9.24 7.08423 12 7.08423C14.76 7.08423 17 9.32423 17 12.0842C17 14.8442 14.76 17.0842 12 17.0842ZM12 9.08423C10.34 9.08423 9 10.4242 9 12.0842C9 13.7442 10.34 15.0842 12 15.0842C13.66 15.0842 15 13.7442 15 12.0842C15 10.4242 13.66 9.08423 12 9.08423Z"
        fill="#DDDDDD"
      />
    </svg>
  );
};
